export default __webpack_public_path__ + "static/media/ic_mauritius.82d4ba80.svg";